(function () {
  function initDeliveryMap(section) {
    if (!section || section.dataset.deliveryMapInitialized === 'true') {
      return;
    }

    var openButton = section.querySelector('[data-delivery-map-open]');
    var closeButton = section.querySelector('[data-delivery-map-close]');
    var modal = section.querySelector('[data-delivery-map-modal]');

    if (!modal) {
      return;
    }

    section.dataset.deliveryMapInitialized = 'true';

    var lastFocusedElement = null;

    function openModal() {
      lastFocusedElement = document.activeElement;

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');

      document.body.style.overflow = 'hidden';

      if (closeButton) {
        closeButton.focus();
      }
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');

      document.body.style.overflow = '';

      if (
        lastFocusedElement &&
        typeof lastFocusedElement.focus === 'function'
      ) {
        lastFocusedElement.focus();
      }
    }

    if (openButton) {
      openButton.addEventListener('click', openModal);
    }

    if (closeButton) {
      closeButton.addEventListener('click', closeModal);
    }

    modal.addEventListener('click', function (event) {
      if (event.target === modal) {
        closeModal();
      }
    });

    section._deliveryMapClose = closeModal;
  }

  function initAllDeliveryMaps(container) {
    var scope = container || document;

    var sections = scope.querySelectorAll
      ? scope.querySelectorAll('[data-delivery-map]')
      : [];

    sections.forEach(function (section) {
      initDeliveryMap(section);
    });

    if (
      scope.matches &&
      scope.matches('[data-delivery-map]')
    ) {
      initDeliveryMap(scope);
    }
  }

  function closeOpenModal() {
    var openModal = document.querySelector(
      '[data-delivery-map-modal].is-open'
    );

    if (!openModal) {
      return;
    }

    var section = openModal.closest('[data-delivery-map]');

    if (
      section &&
      typeof section._deliveryMapClose === 'function'
    ) {
      section._deliveryMapClose();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllDeliveryMaps(document);
    });
  } else {
    initAllDeliveryMaps(document);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeOpenModal();
    }
  });

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initAllDeliveryMaps(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    function (event) {
      var openModal = event.target.querySelector(
        '[data-delivery-map-modal].is-open'
      );

      if (openModal) {
        document.body.style.overflow = '';
      }
    }
  );
})();